const hba1c = {
  parameters: [
    {
      name: 'hba1c',
      displayName: 'HBA1C',
      id: "hba1c",
      validFrom: '2022/05/24 1:00',
      validThrough: null,
      interpretationsSupported: [
        'normal',
        'high',
        'too-high',
        'fault',
      ],
      ranges: [{
        color: '#1f7359',
        description: 'hba1c-normal',
        lowerLimit: 0,
        lowerLimitOperator: '>=',
        upperLimit: 5.7,
        upperLimitOperator: '<',
        unit: '%',
        interpretation: 'normal',
        displayInterpretation: 'Normal',
        rangeInterpretation: '0 - 5.6',
      },
      {
        color: '#fdad02',
        description: 'hba1c-high',
        lowerLimit: 5.7,
        lowerLimitOperator: '>=',
        upperLimit: 6.4,
        upperLimitOperator: '<=',
        unit: '%',
        interpretation: 'high',
        displayInterpretation: 'High',
        rangeInterpretation: '5.7 - 6.4',
      },
      {
        color: '#ef4036',
        description: 'hba1c-too-high',
        lowerLimit: 6.4,
        lowerLimitOperator: '>',
        upperLimit: 20,
        upperLimitOperator: '',
        unit: '%',
        interpretation: 'too-high',
        displayInterpretation: 'Too high',
        rangeInterpretation: '> 6.4',
      }],
    },
  ],
};

export default hba1c;